import StoreLocaterList from './StoreLocaterList';
export default StoreLocaterList;
